import { UseAccount } from '@dustin-web/microsite-data/src/hooks/use-account-internal'
import { useDataLoaderHooks } from './use-dataloader-hooks'

export const useAccount: UseAccount = () => {
  const { account } = useDataLoaderHooks()

  return (
    account() || {
      contactQueryError: null,
      contactQueryData: null,
      customerNavigationData: null,
      customerNavigationError: null,
    }
  )
}
